//Create by Mattias Asplund
import { surveyLocalization } from "survey-core";

export var swedishSurveyStrings = {
  pagePrevText: "Föregående",
  pageNextText: "Nästa",
  completeText: "Slutför",
  previewText: "Förhandsvisning",
  editText: "Redigera",
  startSurveyText: "Börja",
  otherItemText: "Annat (beskriv)",
  noneItemText: "Ingen",
  selectAllItemText: "Välj alla",
  progressText: "Sida {0} av {1}",
  indexText: "{0} av {1}",
  panelDynamicProgressText: "{0} av {1}",
  questionsProgressText: "{0} / {1} frågor besvarade",
  emptySurvey: "Det finns ingen synlig sida eller fråga i enkäten.",
  completingSurvey: "Tack för att du genomfört enkäten!!",
  completingSurveyBefore:
    "Våra register visar att du redan har slutfört denna undersökning.",
  loadingSurvey: "Enkäten laddas...",
  placeholder: "Välj...",
  ratingOptionsCaption: "Tryck här för att betygsätta...",
  value: "värde",
  requiredError: "Frågan är obligatorisk.",
  requiredErrorInPanel: "Vänligen svara på minst en fråga.",
  requiredInAllRowsError: "Var vänlig besvara frågorna på alla rader.",
  numericError: "Värdet ska vara numeriskt.",
  minError: "Värdet får inte vara mindre än {0}",
  maxError: "Värdet får inte vara större än {0}",
  textMinLength: "Ange minst {0} tecken.",
  textMaxLength: "Ange färre än {0} tecken.",
  textMinMaxLength: "Ange mer än {0} och färre än {1} tecken.",
  minRowCountError: "Var vänlig fyll i minst {0} rader.",
  minSelectError: "Var vänlig välj åtminstone {0} varianter.",
  maxSelectError: "Var vänlig välj inte fler än {0} varianter.",
  numericMinMax:
    "'{0}' ska vara lika med eller mer än {1} samt lika med eller mindre än {2}",
  numericMin: "'{0}' ska vara lika med eller mer än {1}",
  numericMax: "'{0}' ska vara lika med eller mindre än {1}",
  invalidEmail: "Var vänlig ange en korrekt e-postadress.",
  invalidExpression: "Uttrycket: {0} ska returnera 'true'.",
  urlRequestError: "Förfrågan returnerade felet '{0}'. {1}",
  urlGetChoicesError:
    "Antingen returnerade förfrågan ingen data eller så är egenskapen 'path' inte korrekt",
  exceedMaxSize: "Filstorleken får ej överstiga {0}.",
  otherRequiredError: "Var vänlig ange det andra värdet.",
  uploadingFile:
    "Din fil laddas upp. Var vänlig vänta några sekunder och försök sedan igen.",
  loadingFile: "Laddar...",
  chooseFile: "Välj fil(er) ...",
  noFileChosen: "Ingen fil vald",
  confirmDelete: "Vill du radera posten?",
  keyDuplicationError: "Detta värde ska vara unikt.",
  addColumn: "Lägg till kolumn",
  addRow: "Lägg till rad",
  removeRow: "Ta bort",
  addPanel: "Lägg till ny",
  removePanel: "Ta bort",
  choices_Item: "Artikel",
  matrix_column: "Kolumn",
  matrix_row: "Rad",
  multipletext_itemname: "text",
  savingData: "Resultaten sparas på servern ...",
  savingDataError: "Ett fel inträffade och vi kunde inte spara resultaten.",
  savingDataSuccess: "Resultaten lyckades sparas!",
  saveAgainButton: "Försök igen",
  timerMin: "min",
  timerSec: "sek",
  timerSpentAll: "Du har spenderat {0} på den här sidan och {1} totalt.",
  timerSpentPage: "Du har spenderat {0} på den här sidan.",
  timerSpentSurvey: "Du har spenderat {0} totalt.",
  timerLimitAll:
    "Du har spenderat {0} av {1} på den här sidan och {2} av {3} totalt.",
  timerLimitPage: "Du har spenderat {0} av {1} på den här sidan.",
  timerLimitSurvey: "Du har spenderat {0} av {1} totalt.",
  clearCaption: "Klar",
  signaturePlaceHolder: "Signera här",
  chooseFileCaption: "Välj fil",
  removeFileCaption: "Ta bort den här filen",
  booleanCheckedLabel: "Ja",
  booleanUncheckedLabel: "Nej",
  confirmRemoveFile: "Är du säker på att du vill ta bort den här filen: {0}?",
  confirmRemoveAllFiles: "Är du säker på att du vill ta bort alla filer?",
  questionTitlePatternText: "Frågetitel",
  modalCancelButtonText: "Avbryt",
  modalApplyButtonText: "Spara",
  filterStringPlaceholder: "Skriv för att söka...",
  emptyMessage: "Ingen data finns",
  noEntriesText: "Det finns inga värden än.\nKlicka på knappen nedan för att lägga till nytt värde.",
  more: "Mer"
};

surveyLocalization.locales["sv"] = swedishSurveyStrings;
surveyLocalization.localeNames["sv"] = "svenska";
